import React from 'react';
import './Stepper.less';
import { Stepper as CustomStepper, Step } from 'react-form-stepper';

type Props = {
  activeStep?: number;
  numberOfSteps?: number;
  numberOfCompletedGroups?: number;
  numberOfIncompletedGroups?: number;
};

const Stepper = ({
  activeStep,
  numberOfSteps,
  numberOfCompletedGroups,
  numberOfIncompletedGroups,
}: Props) => {
  return (
    <div key="custom-stepper-container" className="navigation-stepper">
      <CustomStepper
        key="custom-stepper"
        className="stepper"
        activeStep={activeStep}
        // @ts-ignore
        styleConfig={{
          size: 16,
          activeBgColor: 'white',
          inactiveBgColor: 'white',
          completedBgColor: 'white',
        }}
        // @ts-ignore
        connectorStyleConfig={{
          activeColor: 'black',
          disabledColor: 'white',
          completedColor: 'black',
        }}
      >
        {[...Array(numberOfCompletedGroups)].map((step, index) => (
          <Step label="" key={`step-${index}`}>
            <div key="stepper-tick" className="stepper-tick">
              ✓
            </div>
          </Step>
        ))}
        {[...Array(numberOfIncompletedGroups)].map((step, index) => (
          <Step label="" key={`step-${index}`}>
            <div key="stepper-dot" className="stepper-dot" />
          </Step>
        ))}
      </CustomStepper>
    </div>
  );
};

Stepper.defaultProps = {
  activeStep: null,
  numberOfSteps: 4,
};

export default React.memo(Stepper);
